import { render, staticRenderFns } from "./ProjectDetailPage.vue?vue&type=template&id=572546c2"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetailPage.vue?vue&type=style&index=0&id=572546c2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports